import { FC } from 'react';
import { Button, Col, Input, Row, Switch } from 'antd';
import { TbPlus, TbTrash } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { PlatformForm as Form } from '@/shared/components/forms';

import { validateRedirectUri } from '../../validation';

const OAuthSettingsSection: FC = () => {
    const { token } = useAntDesignTheme();

    return (
        <>
            <Form.List name='redirectUris' initialValue={['']}>
                {(fields, { add, remove }) => (
                    <>
                        <div style={{ marginBottom: '0.5rem' }}>
                            <small style={{ color: token.colorTextTertiary }}>Redirect URIs</small>
                        </div>
                        {fields.map((field) => (
                            <Row key={field.key} gutter={8} align='top'>
                                <Col flex='auto'>
                                    <Form.Item
                                        {...field}
                                        rules={[
                                            { required: true, message: 'Redirect URI is required' },
                                            { validator: validateRedirectUri },
                                        ]}
                                    >
                                        <Input
                                            id={field.name === 0 ? 'oauth-application-field-redirect-uri' : undefined}
                                            placeholder='https://api.example.com/oauth/callback...'
                                        />
                                    </Form.Item>
                                </Col>
                                {fields.length > 1 && (
                                    <Col flex='none'>
                                        <Button
                                            aria-label='Remove redirect URI'
                                            type='text'
                                            danger
                                            icon={<TbTrash />}
                                            onClick={() => remove(field.name)}
                                        />
                                    </Col>
                                )}
                            </Row>
                        ))}
                        <Button type='dashed' block icon={<TbPlus />} onClick={() => add('')}>
                            Add Redirect URI
                        </Button>
                    </>
                )}
            </Form.List>
            <Form.Item
                name='allowPKCE'
                valuePropName='checked'
                label='Allow PKCE'
                extra='Recommended for browser, mobile, and other public clients that cannot protect a client secret.'
                style={{ marginTop: '1rem' }}
            >
                <Switch />
            </Form.Item>
        </>
    );
};

export default OAuthSettingsSection;
